import type { BBUiConfig, ComponentTypes } from 'types/story';
import { COMPONENT_TYPE } from 'common/constants';
import { BOX_TYPE } from 'client/components/common/BuildingBlocks/Box';
import { TimerType } from 'client/components/common/BuildingBlocks/Timer/Timer';
import { AnswerProgressType } from 'client/components/common/BuildingBlocks/AnswerProgress/AnswerProgress';

// Whether building block height can be changed
export const canChangeHeight = (type: ComponentTypes, uiConfig: BBUiConfig) => {
	if (uiConfig.componentProps.styles.alignSelf === 'stretch') {
		return false;
	}

	switch (type) {
		case COMPONENT_TYPE.TEXT:
		case COMPONENT_TYPE.RESULT_TEXT:
		case COMPONENT_TYPE.CHECKBOX:
		case COMPONENT_TYPE.COUNTER:
		case COMPONENT_TYPE.SLIDER_SLIDES:
			return false;
		case COMPONENT_TYPE.ANSWER_PROGRESS:
			return uiConfig.componentProps.answerProgressType === AnswerProgressType.bar;
		case COMPONENT_TYPE.BOX: {
			const boxType = uiConfig.componentProps.other?.boxType;
			return boxType === BOX_TYPE.FRAME || !boxType;
		}
		case COMPONENT_TYPE.TIMER: {
			return uiConfig.componentProps.timerType === TimerType.bar;
		}
		default:
			return true;
	}
};

// Whether building block width can be changed
export const canChangeWidth = (type: ComponentTypes, uiConfig: BBUiConfig) => {
	if (uiConfig.componentProps.styles.justifySelf === 'stretch') {
		return false;
	}

	switch (type) {
		case COMPONENT_TYPE.TIMER: {
			return uiConfig.componentProps?.timerType === TimerType.bar;
		}
		case COMPONENT_TYPE.ANSWER_PROGRESS: {
			return uiConfig.componentProps.answerProgressType === AnswerProgressType.bar;
		}
		case COMPONENT_TYPE.COUNTER:
		case COMPONENT_TYPE.SLIDER_SLIDES: {
			return false;
		}
		default:
			return true;
	}
};
